var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brush-record-page"},[_c('h2',[_vm._v("刷脸记录")])])
}]

export { render, staticRenderFns }